'use strict'
export const apiUrl = '//testback-chienowa.n-links.biz'
export const authUrl = '//testauth.n-links.biz'
export const myUrl = 'testchienowa.n-links.biz'
export const appName = 'chienowa-test'



//////////////////
// WEBPACK FOOTER
// ./config/env.js
// module id = AMf1
// module chunks = 41